
export type TResult = {
    order: number,
    name: string,
    time: string
} 

export const results2021 : Array<TResult> = [
    {
        order: 1,
        name: "FORMULE JEDE",
        time: "75 minut"
    },
    {
        order: 2,
        name: "ZCELA STARÉ KŘÍŽE",
        time: "93 minut"
    },
    {
        order: 3,
        name: "KRAJNĚ ROZŠAFNÝ TRKAČ",
        time: "104 minut"
    },
    {
        order: 4,
        name: "KVĚTÁCI",
        time: "121 minut"
    },
    {
        order: 5,
        name: "LOS CMUNTOS",
        time: "124 minut"
    },
    {
        order: 6,
        name: "CIBULÁCI",
        time: "130 minut"
    },
    {
        order: 7,
        name: "NEBLUDNÍ HOLANĎANÉ",
        time: "134 minut"
    },
    {
        order: 8,
        name: "VOMÍCI",
        time: "135 minut"
    },
    {
        order: 9,
        name: "GWINT - HAFFO",
        time: "153 minut"
    },
    {
        order: 10,
        name: "ŠIK HOLKY",
        time: "156 minut"
    },
    {
        order: 11,
        name: "LIŠKOLOUŠCI",
        time: "203 minut"
    },
    {
        order: 12,
        name: "MIMONI a S.E.P.A.R.A.C.E.",
        time: "204 minut"
    },
    {
        order: 13,
        name: "LIŠTIČKY",
        time: "235 minut"
    },
    {
        order: 14,
        name: "SMÚSÁCI",
        time: "255 minut"
    },
    {
        order: 15,
        name: "GEPARDI",
        time: "262 minut"
    },
]

export const results2022: Array<TResult> = [
    {
        order: 1,
        name: "Formule znovu jede",
        time: "2:12:02"
    },
    {
        order: 2,
        name: "Kouleňové",
        time: "2:19:14"
    },
    {
        order: 3,
        name: "Pšt!",
        time: "2:29:52"
    },
    {
        order: 4,
        name: "Tekuté jehličí",
        time: "2:40:44"
    },
    {
        order: 5,
        name: "Do počtu",
        time: "2:47:40"
    },
    {
        order: 6,
        name: "Pivní lezci",
        time: "2:53:01"
    },
    {
        order: 7,
        name: "Tym",
        time: "3:02:20"
    },
    {
        order: 8,
        name: "Zcela staré kříže",
        time: "3:17:16"
    },
    {
        order: 9,
        name: "Škodíci",
        time: "3:20:01"
    },
    {
        order: 10,
        name: "Green team",
        time: "3:21:15"
    },
    {
        order: 11,
        name: "Princezny",
        time: "3:22:43"
    },
    {
        order: 12,
        name: "Kato na výletě",
        time: "3:40:12"
    },
    {
        order: 13,
        name: "ČeWe",
        time: "3:44:12"
    },
    {
        order: 14,
        name: "S.e.p.a.r.a.c.e.",
        time: "3:45:37"
    },
    {
        order: 15,
        name: "Veselé Horky",
        time: "3:46:09"
    },
    {
        order: 16,
        name: "Záleží na počasí",
        time: "3:51:42"
    },
    {
        order: 17,
        name: "Knihmil",
        time: "3:54:33"
    },
    {
        order: 18,
        name: "Dvě grácie",
        time: "3:57:33"
    },
    {
        order: 19,
        name: "Už tam budem",
        time: "4:09:03"
    },
    {
        order: 20,
        name: "Přílepkovi",
        time: "4:29:55"
    },
    {
        order: 21,
        name: "Stužkonoska modrá",
        time: "4:41:19"
    },
    {
        order: 22,
        name: "Čendáno",
        time: "4:49:40"
    },
    {
        order: 23,
        name: "Prchající myš",
        time: "4:51:20"
    },
    {
        order: 24,
        name: "Parťačky",
        time: "5:00:50"
    },
    {
        order: 25,
        name: "Kozlíci",
        time: "5:01:26"
    },
    {
        order: 26,
        name: "Pučíci",
        time: "5:43:30"
    },
    {
        order: 27,
        name: "Fosilky",
        time: "5:48:00"
    },
    {
        order: 28,
        name: "#Deka",
        time: "6:06:10"
    },
    {
        order: 29,
        name: "Polojasno",
        time: "6:11:15"
    },
    {
        order: 30,
        name: "Trojlístek",
        time: "7:29:11"
    }
]

export const results2023: Array<TResult> = [
    {
        order: 1,
        name: "Proudoví krtci",
        time: "1:52:49"
    },
    {
        order: 2,
        name: "JIMI",
        time: "2:05:34"
    },
    {
        order: 3,
        name: "lupi",
        time: "2:15:38"
    }
]

export const results2024Z: Array<TResult> = [
    {
        order: 1,
        name: "Studny",
        time: "1:34:37"
    },
    {
        order: 2,
        name: "Nevyšlo počasí",
        time: "1:42:58"
    },
    {
        order: 3,
        name: "ó náš pán krákorá",
        time: "1:50:27"
    }
]

export const results2024P: Array<TResult> = [
    {
        order: 1,
        name: "Krtkův fanklub",
        time: "2:46:06"
    },
    {
        order: 2,
        name: "Erdbeermarmeladebrot",
        time: "2:56:16"
    },
    {
        order: 3,
        name: "Trochu v tom plaveme",
        time: "3:39:51"
    }
]

export const results2025Z: Array<TResult> = [
    {
        order: 1,
        name: "Nazgúlci",
        time: "1:55:16"
    },
    {
        order: 2,
        name: "ó náš pán krákorá",
        time: "2:11:20"
    },
    {
        order: 3,
        name: "Hafcusovi",
        time: "2:33:47"
    }
]

export const results2025P: Array<TResult> = [
    {
        order: 1,
        name: "Jojo",
        time: "2:49:47"
    },
    {
        order: 2,
        name: "KapYtáni",
        time: "3:38:45"
    },
    {
        order: 3,
        name: "Astlhof",
        time: "3:55:39"
    }
]

export const results2026Z: Array<TResult> = [
    {
        order: 1,
        name: "RICHMANI",
        time: "3:27:07"
    },
    {
        order: 2,
        name: "#DEKA",
        time: "3:31:07"
    },
    {
        order: 3,
        name: "Havran",
        time: "3:38:32"
    }
]

export const results2026P: Array<TResult> = [
    {
        order: 1,
        name: "Usnese se se sestrou",
        time: "5:48:43"
    },
    {
        order: 2,
        name: "Mufáci",
        time: "6:21:13"
    },
    {
        order: 3,
        name: "Bez Kurzívy",
        time: "6:38:34"
    }
]
